<template>
  <div class="app__resultList" >
    <div class="resultListHead">
      <div v-show="mapOnLoading">検索中</div>
      <div v-show="!mapOnLoading">
        <span>地図上に表示されている施設数</span>
        <span class="numOfResult">{{markersCount}}</span>
        <span>件</span>
      </div>
    </div>
    <ul class="resultListBody">
      <div class="loading_spinner" v-show="mapOnLoading">
        <vue-loading
          type="spin"
          color="#008B54"
          :size="{ width: '50px', height: '50px' }"
          >
        </vue-loading>
      </div>
      <div v-show="!mapOnLoading">
        <div v-for="(map, index) in mapMarkers" :key="index" v-show="!mapOnLoading">
          <nursing-care-facility :map="map" @onCardSelected="onCardSelected" v-if="!map.is_sonaeru_center" />
        </div>
      </div>
    </ul>
    <button class="toggleButton" @click="onToggleButtonClicked"></button>
  </div>
</template>

<script>
  import NursingCareFacility from './nursing_care_facility.vue';
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { VueLoading } from 'vue-loading-template'
  export default {
    name: 'ResultList',
    components: { NursingCareFacility, VueLoading },
    data() {
      return {
      }
    },
    computed: {
      markersCount() {
        return this.mapMarkers.length
      },
      ...mapGetters('map', ['mapMarkers', 'mapOnLoading', 'mapResultListOpen']),
    },
    methods: {
      onCardSelected(map){
        this.$emit('onCardSelected', map)
      },
      onToggleButtonClicked(){
        if(this.mapResultListOpen){
          $(".toggleButton").addClass("active")
          $(".app__resultList").addClass("move-to-left")
          this.$store.commit('map/setResultListOpen', false)
        }else{
          $(".toggleButton").removeClass("active")
          $(".app__resultList").removeClass("move-to-left")
          this.$store.commit('map/setResultListOpen', true)
        }
      }
    },
  }
</script>
